import {
  CreateCartParentGA4Object,
  CreateCartItemsObject,
} from 'cart-helpers-v2';

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {bubbles: true});
    this.quickAsParent = this.closest('.petivity-quick-view__quantity-wrapper');

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );

    if (this.quickAsParent && this.input.value <= 1) {
      this.querySelector('button[name="minus"]').setAttribute('disabled', true);
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      this.input.stepUp();
      this.querySelector('button[name="minus"]').removeAttribute('disabled');
    } else {
      this.input.stepDown();
      if (this.quickAsParent && this.input.value <= 1) {
        this.querySelector('button[name="minus"]').setAttribute(
          'disabled',
          true,
        );
      }
    }

    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    const ns_quantity_input = {
      SubTotalEl: document.getElementById('subTotal'),

      RemoveCartItem(e) {
        if (event.target.name === 'minus') {
          const cartItem = e.target.closest('.cart-item');
          if (cartItem) {
            CreateCartItemsObject(
              cartItem,
              CreateCartParentGA4Object(
                'remove_from_cart',
                ns_quantity_input.SubTotalEl,
              ),
              true,
              e,
            );
          }
        }
      },

      AddCartItem(e) {
        if (event.target.name === 'plus') {
          const cartItem = e.target.closest('.cart-item');
          if (cartItem) {
            CreateCartItemsObject(
              cartItem,
              CreateCartParentGA4Object(
                'add_to_cart',
                ns_quantity_input.SubTotalEl,
              ),
              true,
              e,
            );
          }
        }
      },
    };

    // Capture GA4 data - 'remove_from_cart'
    ns_quantity_input.RemoveCartItem(event);

    // Capture GA4 data - 'add_to_cart'
    ns_quantity_input.AddCartItem(event);

    const mainProduct = this.closest('.product__info-wrapper');

    if (mainProduct) {
      const productFormQuantity = mainProduct.querySelector(
        '.product-form__quantity',
      );
      const enabledChangePrice = productFormQuantity.classList.contains(
        'enabled_change_price',
      );

      if (enabledChangePrice) {
        const newPrice = productFormQuantity.dataset.newPrice;
        const originalPrice = productFormQuantity.dataset.originalPrice;
        const salePriceBlock = mainProduct.querySelector(
          '.price-item.price-item--sale',
        );
        const regularPriceBlock = mainProduct.querySelector(
          's.price-item.price-item--regular',
        );
        const priceWrapper = mainProduct.querySelector(
          '.product__info-container',
        );
        const customTexts = mainProduct.querySelectorAll(
          '.custom-text-wrapper',
        );

        if (this.input.value > 1) {
          priceWrapper.classList.add('price--on-sale');
          regularPriceBlock.textContent = `$${originalPrice}`;
          salePriceBlock.textContent = `$${newPrice}`;

          const savings = (
            parseFloat(regularPriceBlock.textContent.replace('$', '')) -
            parseFloat(newPrice)
          ).toFixed(2);

          customTexts.forEach((customText) => {
            customText.textContent = `You’re saving $${savings * this.input.value}`;
          });
        } else {
          priceWrapper.classList.remove('price--on-sale');
          customTexts.forEach((customText) => {
            const originalText = customText.dataset.customText;
            customText.textContent = originalText;
          });
        }
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput);
